import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_USER_PROGRAM_ORDER_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_ORDER_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_ORDER_LIST_API_ID,
  (params: {}) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/user-program-orders`,
      params: { ordering: '-order_date', ...params },
    }),
    method: 'GET',
  })
);

export default apiCall;
